module.exports = __webpack_public_path__ + "static/media/homen-rural.7052f58f.png";